export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';
import type {SenderAttachment, MessageSendPayload} from 'kpc';

interface Props {
    value?: string
    attachments?: SenderAttachment[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: '', attachments: []};
    }

    getUploadProps() {
        return {
            action: 'https://httpbin.org/post',
            timeout: 15000,
            accept: '.pdf,.doc,.docx,image/*',
            multiple: true,
            limit: 5,
            mapAttachment: (file: File) => ({
                loadingText: `正在上传`,
                errorText: `上传失败了噢`,
            }),
        };
    }

    @bind
    onMessageSend(payload: MessageSendPayload) {
        console.log('send', payload.value, payload.attachments);
    }

    @bind
    onUploadProgress(e: ProgressEvent, file: SenderAttachment) {
        console.log('upload progress', file.name, e);
    }

    @bind
    onUploadSuccess(res: any, file: SenderAttachment) {
        console.log('upload success', file.name, res);
    }

    @bind
    onUploadError(error: Error, file?: SenderAttachment) {
        console.log('upload error', file?.name, error.message);
    }
}